import { render, staticRenderFns } from "./FirmDashboard.vue?vue&type=template&id=59652fe0&scoped=true&"
import script from "./FirmDashboard.vue?vue&type=script&lang=ts&"
export * from "./FirmDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./FirmDashboard.vue?vue&type=style&index=0&id=59652fe0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59652fe0",
  null
  
)

export default component.exports